import moment from 'moment'

const minuteSplit = 15;
export function reMapGetCountData(logJson) {


    const totalPeopleCount_in = logJson.filter(log => log.zone === "person").reduce((a, b) => a + b.count_in, 0)
    const totalPeopleCount_out = logJson.filter(log => log.zone === "person").reduce((a, b) => a + b.count_out, 0)
    const totalCarCount_in = logJson.filter(log => log.zone === "car").reduce((a, b) => a + b.count_in, 0)
    const totalCarCount_out = logJson.filter(log => log.zone === "car").reduce((a, b) => a + b.count_out, 0)
    const totalSectors = [...new Set(logJson.map(item => item.sector))];
    const sectorwisePeople_in = totalSectors.map(sector => { return logJson.filter(log => log.sector === sector && log.zone === "person").reduce((a, b) => a + b.count_in, 0) })
    const sectorwiseCar_in = totalSectors.map(sector => { return logJson.filter(log => log.sector === sector && log.zone === "car").reduce((a, b) => a + b.count_in, 0) })
    const sectorwisePeople_out = totalSectors.map(sector => { return logJson.filter(log => log.sector === sector && log.zone === "person").reduce((a, b) => a + b.count_out, 0) })
    const sectorwiseCar_out = totalSectors.map(sector => { return logJson.filter(log => log.sector === sector && log.zone === "car").reduce((a, b) => a + b.count_out, 0) })

    let timeLabelsTime = []
    let startTimeLabel = moment().startOf('day').add("9", "hours")
    let endDate = moment().add(30, "minutes")
    do {
        timeLabelsTime.push(startTimeLabel.format("YYYY-MM-DD HH:mm:ss"));
        startTimeLabel = moment(startTimeLabel)
            .add(minuteSplit, "minutes")
            .clone();
    } while (moment(startTimeLabel).isBefore(endDate));

    const peopleCountTimeIn = consolidateLogIn(timeLabelsTime, logJson, "person")
    const peopleCountTimeOut = consolidateLogOut(timeLabelsTime, logJson, "person")

    const carCountTimeIn = consolidateLogIn(timeLabelsTime, logJson, "car")
    const carCountTimeOut = consolidateLogOut(timeLabelsTime, logJson, "car")


    const payload = {
        totalPeopleCount_in: totalPeopleCount_in,
        totalPeopleCount_out: totalPeopleCount_out,
        totalCarCount_in: totalCarCount_in,
        totalCarCount_out: totalCarCount_out,
        sectorwisePeople_in: sectorwisePeople_in,
        sectorwiseCar_in: sectorwiseCar_in,
        sectorwisePeople_out: sectorwisePeople_out,
        sectorwiseCar_out: sectorwiseCar_out,
        peopleCountTimeIn: peopleCountTimeIn,
        peopleCountTimeOut: peopleCountTimeOut,
        carCountTimeIn: carCountTimeIn,
        carCountTimeOut: carCountTimeOut,
        timeLabelsTime: timeLabelsTime,
        totalSectors: totalSectors

    }
    console.log(payload)

    return payload;
}


const consolidateLogIn = (timeLabelsTime, PeopleCount, objectType) => {
    let consolidatedData = timeLabelsTime.map(mytime => {
        let counts_slice = PeopleCount.filter(log => log.zone === objectType).filter(count => {
            let endValue = moment(mytime).valueOf();
            let startValue = moment(mytime)
                .add(-minuteSplit, "minutes")
                .valueOf();
            let objValue = moment(count.count_time).valueOf();

            if (objValue < endValue && objValue > startValue) {
                return count;
            } else {
                return null;
            }
        });

        return counts_slice.reduce((acc, val) => {
            return acc + val.count_in;
        }, 0);
    });

    return consolidatedData;
};

const consolidateLogOut = (timeLabelsTime, PeopleCount, objectType) => {
    let consolidatedData = timeLabelsTime.map(mytime => {
        let counts_slice = PeopleCount.filter(log => log.zone === objectType).filter(count => {
            let endValue = moment(mytime).valueOf();
            let startValue = moment(mytime)
                .add(-minuteSplit, "minutes")
                .valueOf();
            let objValue = moment(count.count_time).valueOf();

            if (objValue < endValue && objValue > startValue) {
                return count;
            } else {
                return null;
            }
        });

        return counts_slice.reduce((acc, val) => {
            return acc + val.count_out;
        }, 0);
    });

    return consolidatedData;
};